// iOS系统
export const isIos = () => {
  let u = window.navigator.userAgent
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

// iOS9系统
export const isIos9 = () => {
  // 判断是否 iPhone 或者 iPod
  if ((navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i))) {
    // 判断系统版本号是否大于9
    return Boolean(navigator.userAgent.match(/OS ([9]|1[0-9])_\d[_\d]* like Mac OS X/i))
    // OS 11_0 like Mac OS X
  } else {
    return false
  }
}

// Android系统
export const isAndroid = () => {
  let u = window.navigator.userAgent
  return u.indexOf('android') > -1 || u.indexOf('Linux') > -1
}

// 鸿蒙NEXT系统
export const isHarmonyOS = () => {
  let u = window.navigator.userAgent.toLowerCase()
  return u.indexOf('arkweb') >= 0
}

// PC
export const isPc = () => {
  let userAgentInfo = window.navigator.userAgent
  let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }
  return flag
}